
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "./Pagination/Pagination.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_Carousel";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_Carousel__root","controls":"wds_1_209_0_Carousel__controls","imageContainer":"wds_1_209_0_Carousel__imageContainer","image":"wds_1_209_0_Carousel__image","loader":"wds_1_209_0_Carousel__loader","pagination":"wds_1_209_0_Carousel__pagination","pageNavigation":"wds_1_209_0_Carousel__pageNavigation"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"dotHeight":"4px","arrowMarginFromSide":"12px","horizontalSpacingSize":"25px","verticalSpacingSize":"calc((var(--wds-space-400, 24px) + 4px) / 2)"}; 
export var vars = {"wds-space-100":"--wds-space-100","wds-space-200":"--wds-space-200","wds-space-300":"--wds-space-300","wds-space-400":"--wds-space-400","wds-shadow-300":"--wds-shadow-300","wds-color-fill-surface-neutral":"--wds-color-fill-surface-neutral","wds-button-size-tiny":"--wds-button-size-tiny","wds-button-size-small":"--wds-button-size-small","wds-button-size-medium":"--wds-button-size-medium","wds-button-size-large":"--wds-button-size-large","wds-color-gradient-light-left-to-right":"--wds-color-gradient-light-left-to-right","wds-color-gradient-light-right-to-left":"--wds-color-gradient-light-right-to-left","arrow-size":"--wds_1_209_0_Carousel-arrow-size","carousel-gradient-color":"--carousel-gradient-color"}; 




